import { ComponentConfig } from '@measured/puck';
import CustomTooltip from '../../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../../services/constants';
import {
  getcurrentDeviceType,
  getMarginStyles,
  resolveShowComponentField,
} from '../../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import { MarginProps, marginFields } from '../../../puck/reusable-props/margin';
import { boxShadows } from '../../../../page-builder/puck/reusable-props/options';
import { backgroungFields } from '../../../puck/reusable-props/backgroungFields';

export type DividerProps = {
  size: string;
  direction: string;
  background: {
    color: string;
    isInherit: boolean;
  };
  boxShadow: 'none' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl';
} & showComponentProps &
  MarginProps;

const sizeOptions = [
  { label: '1px', value: '1px' },
  { label: '2px', value: '2px' },
  { label: '3px', value: '3px' },
  { label: '4px', value: '4px' },
];

const directionOptions = [
  { label: 'horizontal', value: 'height' },
  { label: 'vertical', value: 'width' },
];

export const Divider = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<DividerProps> => {
  return {
    label: (
      <CustomTooltip title="Divider">
        <span>Divider</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...backgroungFields,
      size: {
        type: 'select',
        options: sizeOptions,
      },
      direction: {
        type: 'select',
        options: directionOptions,
      },
      boxShadow: {
        label: 'Shadow',
        type: 'select',
        options: boxShadows,
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      size: '1px',
      direction: 'height',
      boxShadow: 'none',
      background: {
        color: '#000000',
        isInherit: false,
      },
      margin: {
        desktop: {
          top: '12',
          bottom: '12',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '12',
          bottom: '12',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '10',
          bottom: '10',
          right: '0',
          left: '0',
        },
      },
    },
    resolveFields: ({ props }, { fields }) =>
      resolveShowComponentField(props.id, fields),
    render: ({
      size,
      direction,
      background,
      boxShadow,
      showComponent,
      margin,
      editMode,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              className={`${boxShadow}`}
              style={{
                ...marginStyles,
                [direction]: size,
                [direction === 'height' ? 'width' : 'height']: '100%',
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
              }}
            />
          )}
        </>
      );
    },
  };
};
